import React from "react";
import { label } from "../../../config";
import "./FormDimensionReadOnly.scss";

/**
 * Read-only header when a form dimension element is selected in the properties sidebar.
 * @param {Object} props
 * @param {Object} props.element - Selected canvas element (form dimension)
 * @param {function(string|number, Object): void} props.onFieldPropertiesChange - Updates element properties
 * @author Abhishek Dhillon
 * @component FormDimensionReadOnly
 */
const FormDimensionReadOnly = ({ element, onChange }) => {
  const showChipName = element?.properties?.showChipName ?? true;
  return (
    <div className='form-dimension-read-only mb-2'>
      <div className='text-truncate form-sub-heading form-dimension-read-only__title'>{element?.name}</div>
      <p className='text-muted small mb-0'>{label.READ_ONLY_DIMENSION}</p>
      <div className='row'>
        <div className='col-6'>
          <label>{label.CHIP_NAME}</label>
        </div>
        <div className='col-6'>
          <div>
            <button
              type='button'
              id='form-properties-admin-chip-show-chip-name'
              className={`form-admin-chip-properties__chip-name-btn form-admin-chip-properties__chip-name-btn--left ${
                showChipName ? "form-admin-chip-properties__chip-name-btn--active" : "form-admin-chip-properties__chip-name-btn--inactive"
              }`}
              onClick={() => onChange(element?.id, { showChipName: true })}>
              {label.SHOW}
            </button>
            <button
              type='button'
              id='form-properties-admin-chip-hide-chip-name'
              className={`form-admin-chip-properties__chip-name-btn form-admin-chip-properties__chip-name-btn--right ${
                !showChipName ? "form-admin-chip-properties__chip-name-btn--active" : "form-admin-chip-properties__chip-name-btn--inactive"
              }`}
              onClick={() => onChange(element?.id, { showChipName: false })}>
              {label.HIDE}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormDimensionReadOnly;
